export default __webpack_public_path__ + "static/media/CAA.7b91224c.png";